import { useState } from 'preact/hooks';
import { formatCode, get, media } from '../api';
import { Card, Empty, Link, Loading, Pill, useLoad } from '../ui';

export function GameCard(p: { g: any; mine?: boolean }) {
	const g = p.g;
	return (
		<Link href={`/g/${g.code}`} class="game-card">
			<div class="game-cover" style={g.cover ? { backgroundImage: `url(${media(g.cover, 640)})` } : undefined}>
				{g.locked ? <span class="lock" title="Password protected">🔒</span> : null}
				<Pill tone={g.status === 'active' ? 'ok' : g.status === 'ended' ? 'muted' : 'accent'}>{g.status === 'active' ? 'In progress' : g.status === 'ended' ? 'Ended' : 'Lobby'}</Pill>
			</div>
			<div class="game-body">
				<h3>{g.name}</h3>
				<p class="muted small">
					{g.template ? `${g.template} · ` : ''}GM {g.gm}
				</p>
				<p class="small clamp">{g.description}</p>
				<div class="game-meta">
					<span>
						{g.seatsTaken}/{g.seats} seats
					</span>
					{g.unclaimed ? <span>{g.unclaimed} open character{g.unclaimed > 1 ? 's' : ''}</span> : null}
					<span>{g.rating}</span>
					<span>{g.timer}s timer</span>
					{p.mine && g.myRole ? <Pill tone="accent">{g.myRole}</Pill> : null}
				</div>
				<code class="code">{formatCode(g.code)}</code>
			</div>
		</Link>
	);
}

export function Browse() {
	const [q, setQ] = useState('');
	const [open, setOpen] = useState(false);
	const [rating, setRating] = useState('');
	const [status, setStatus] = useState('');
	const [unlocked, setUnlocked] = useState(false);
	const [tag, setTag] = useState('');
	const params = new URLSearchParams();
	if (q) params.set('q', q);
	if (open) params.set('open', '1');
	if (rating) params.set('rating', rating);
	if (status) params.set('status', status);
	if (unlocked) params.set('unlocked', '1');
	if (tag) params.set('tag', tag.trim().toLowerCase());
	const qs = params.toString();
	const list = useLoad(() => get(`/api/games?${qs}`), [qs]);
	return (
		<main class="page">
			<h1>Find a game</h1>
			<Card>
				<div class="filters">
					<input type="search" placeholder="Search by name, story, GM or tag" value={q} onInput={(e) => setQ(e.currentTarget.value)} aria-label="Search" />
					<select value={rating} onChange={(e) => setRating(e.currentTarget.value)} aria-label="Content rating">
						<option value="">Any rating</option>
						{['G', 'PG', 'PG-13', 'R'].map((r) => (
							<option key={r}>{r}</option>
						))}
					</select>
					<select value={status} onChange={(e) => setStatus(e.currentTarget.value)} aria-label="Status">
						<option value="">Lobby or in progress</option>
						<option value="lobby">Lobby</option>
						<option value="active">In progress</option>
					</select>
					<input placeholder="Tag" value={tag} onInput={(e) => setTag(e.currentTarget.value)} aria-label="Tag" class="tag-input" />
					<label class="check">
						<input type="checkbox" checked={open} onChange={(e) => setOpen(e.currentTarget.checked)} /> Open seats
					</label>
					<label class="check">
						<input type="checkbox" checked={unlocked} onChange={(e) => setUnlocked(e.currentTarget.checked)} /> No password
					</label>
				</div>
			</Card>
			{!list.data ? <Loading /> : list.data.games.length ? (
				<div class="grid-cards">
					{list.data.games.map((g: any) => (
						<GameCard key={g.code} g={g} />
					))}
				</div>
			) : (
				<Empty>No games match. Try fewer filters, or start your own.</Empty>
			)}
		</main>
	);
}
